import { render } from "./media-section.vue?vue&type=template&id=2b94550e"
import script from "./media-section.vue?vue&type=script&lang=js"
export * from "./media-section.vue?vue&type=script&lang=js"

import "./media-section.vue?vue&type=style&index=0&id=2b94550e&lang=scss"

import exportComponent from "/Users/ian/codebase/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__